import { createStyles } from 'antd-style';

const useStyles = createStyles(() => {
  return {
    'abc-model-container': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      marginBottom: '30px',
    },
    'abc-model--row': {
      'width': '100%',
      'display': 'flex',
      'justifyContent': 'center',
      '& .ant-row': {
        width: '100%',
        justifyContent: 'center',
      },
    },
    'abc-model--tooltip': {
      minWidth: '50%',
    },
    'abc-models--question-container': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      margin: '10px 0',
    },
    'abc-models--consequences-row': {
      display: 'flex',
      alignItems: 'center',
      maxWidth: '300px',
      margin: '10px 0',
    },
    'abc-models--consequences-row-label': {
      marginRight: '7px',
      fontWeight: 600,
    },
    'abc-models--consequences-row-value': {
      flexFlow: 'wrap',
    },
  };
});
export default useStyles;
